// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'mlc-dev',
    appId: '1:526507237982:web:586e90467fc551b7908acf',
    databaseURL: 'https://mlc-dev.firebaseio.com',
    storageBucket: 'mlc-dev.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyC0TTta5egRJ0LxDSeEvd8BhLrGG9IPQRk',
    authDomain: 'mlc-dev.firebaseapp.com',
    messagingSenderId: '526507237982',
    measurementId: 'G-Z8RYZWC3P3',
  },
  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
